// extracted by mini-css-extract-plugin
export default {"container":"UnauthorizedPage_container__ik2d3","title":"UnauthorizedPage_title__WofqM","message":"UnauthorizedPage_message__LR6iH","homeLink":"UnauthorizedPage_homeLink__bKAs3"};